import { Switch, Route } from "react-router-dom";
import Home from "./pages/Home";
import Tables from "./pages/Tables";
// import Billing from "./pages/Billing";
// import Rtl from "./pages/Rtl";
// import Profile from "./pages/Profile";
import SignUp from "./pages/SignUp";
import InvestmentInfo from "./pages/info/InvestmentInfo";
import LendingInfo from "./pages/info/LendingInfo";
import SavingInfo from "./pages/info/SavingInfo";
import BorrowInfo from "./pages/info/BorrowInfo";
import SignIn from "./pages/SignInA";
import Nolonger from "./pages/Nolonger";
// import SignIn from "./pages/SignIn";
import front from "./pages/front";
import Main from "./components/layout/Main";
import "antd/dist/antd.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
// import Info from "./Info";

function App() {
  const loggedin = false;
  const UsefullV2 = false;
  return (
    <div style={{ overflow: "hidden" }}>
      <Switch>
        <Route
          path="/sign-up"
          exact
          component={UsefullV2 ? SignUp : Nolonger}
        />
        <Route path="/sign-in" exact component={SignIn} />
        <Route path="/home" exact component={front} />
        <Route exact path="/" component={front} />

        <Main>
          <Route exact path="/home" component={Home} />

          <Route
            exact
            path="/investment"
            component={loggedin ? Tables : InvestmentInfo}
          />
          <Route exact path="/lending" component={LendingInfo} />
          <Route exact path="/saving" component={SavingInfo} />
          <Route exact path="/borrow" component={BorrowInfo} />
          <Route exact path="/front" component={front} />
          {/* <Route exact path="/investmentinfo" component={InvestmentInfo} /> */}

          {/* <Redirect from="*" to="/home" /> */}
        </Main>
      </Switch>
    </div>
  );
}

export default App;
